import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

import { configureStore } from "@reduxjs/toolkit";
import { Provider } from 'react-redux';
import rootReducer from "./slices";


const store = configureStore({ reducer: rootReducer, devTools: true });



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
    <Provider store={store}>
    <App />
     </Provider>
    </BrowserRouter>
  </React.StrictMode>
);


reportWebVitals();
